<template>
  <div class="home">
    <header>
    <div class="columns is-mobile is-gapless is-vcentered">
      <div class="column is-3">
        <img class="logo" alt="Putter Mayhem" src="../assets/social_logomark.png">
      </div>
      <div class="column is-9 has-text-left">
        <h1 class="has-text-weight-bold">Putter Mayhem Mini Golf Hire</h1>
        <span class="url">https://portable.golf</span>
      </div>
    </div>
    </header>

    <div class="columns">
      <div class="column is-12">
        <table width="100%" class="table is-narrow score-table is-fullwidth">
          <thead>
            <tr class="has-text-weight-bold is-danger">
              <td class="is-danger">Hole</td>
              <td class="is-danger">Par</td>
              <td class="is-danger">P1</td>
              <td class="is-danger">P2</td>
              <td class="is-danger">P3</td>
              <td class="is-danger">P4</td>
            </tr>
          </thead>
          <tbody>
            <!-- Loop through holes in holes object -->
            <tr v-for="hole in holes" :key="hole.number" :class="{highlight:hole.number == current}" @click="current = hole.number">
              <td><p style="padding-top: 8px;">{{ hole.number }}</p></td>
              <td class="has-text-weight-bold"><p style="padding-top: 8px;">{{ hole.par }}</p></td>
              <td><input @keyup="updateScore()" class="input p1" type="number"></td>
              <td><input @keyup="updateScore()" class="input p2" type="number"></td>
              <td><input @keyup="updateScore()" class="input p3" type="number"></td>
              <td><input @keyup="updateScore()" class="input p4" type="number"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="scores">
      <Course :number="holeInformation.number" :name="holeInformation.name" :par='holeInformation.par' :length="holeInformation.length" :description="holeInformation.description" />
      <Scores :scores="scores" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Course from '@/components/Course'
import Scores from '@/components/Scores'
import holes from '@/holes.json'

export default {
  name: 'home',
  data: function() {
    return {
      holes: holes,
      current: 1,
      scores: {
        player_one: 0,
        player_two: 0,
        player_three: 0,
        player_four: 0,
      }
    }
  },
  components: {
    Course,
    Scores
  },
  methods: {
    updateScore: function () {
      let players = ['p1', 'p2', 'p3', 'p4'];
      let scores = [];
      players.forEach(player => {
        let inputs = document.querySelectorAll('.' + player);
        let totalScore = 0;

        inputs.forEach(input => {
          totalScore = totalScore + Number(input.value);
        });

        scores.push(totalScore);
      });

      this.scores.player_one = scores[0];
      this.scores.player_two = scores[1];
      this.scores.player_three = scores[2];
      this.scores.player_four = scores[3];
    }
  },
  computed: {
    holeInformation() {
      let holeInfo = {
        number: this.holes[this.current].number,
        name: this.holes[this.current].name,
        par: this.holes[this.current].par,
        length: this.holes[this.current].length,
        description: this.holes[this.current].description
      };

      return holeInfo;
    }
  }
}
</script>

<style lang="scss">
  .home {
    margin-bottom: 210px;
  }
  header {
    background: white;

    a {
      color: grey;
      font-weight: bold;
      font-size: 0.8em;
    }

    .url {
      color: grey;
      font-size: 0.9em;
    }
  }

  .score-table {
    // font-size: 0.8em;
    // margin: 10px;
    border-radius: 10px;;
  }

    .scores {
      background: #076533;        
      // font-weight: bold;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      // padding: 10px 20px;
        // color: white;
    }

  .logo {
    padding: 10px;
    width: 75px;
  }

  .highlight {
    background: #f5f5f5;
  }

  thead {
    color: red !important;
    border-radius: 3px !important;
  }

  tfoot {
    background: #333 !important;
    td {
      color: white !important;
    }
  }

  .input {
    width: 80%;
    font-size: 1em !important;
  }
</style>